import React from 'react'
import classnames from 'classnames'

const CLASS_STICKY_NODE = 'sticky-menu'
const CLASS_STICKY_NODE_CONTAINER = `${CLASS_STICKY_NODE}-container`
const CLASS_VISIBLE = `${CLASS_STICKY_NODE}--visible`

const defaultItems = [
    { value: 'mt-demo', label: 'Demo' },
    { value: 'mt-catalog', label: 'API Catalog' },
    { value: 'mt-resources', label: 'Resources' },
]

class StickyMenu extends React.Component {
    constructor(props) {
        super(props)
        this.bar = React.createRef()
        this.barContainer = React.createRef()
        let active = 'demo'
        if (window && window.location && window.location.hash) {
            active = window.location.hash.slice(1)
        }

        this.state = { active }
    }

    componentDidMount() {
        const stickyBar = this.bar.current
        const stickyBarContainer = this.barContainer.current

        const sticky = () => {
            const showBar =
                stickyBarContainer.getBoundingClientRect().top <
                stickyBar.getBoundingClientRect().height
            if (showBar) {
                stickyBar.classList.add(CLASS_VISIBLE)
            } else {
                stickyBar.classList.remove(CLASS_VISIBLE)
            }
        }

        window.addEventListener('resize', sticky)
        window.addEventListener('scroll', sticky)

        sticky()
    }

    render() {
        const { items = defaultItems } = this.props

        return (
            <div
                className={CLASS_STICKY_NODE_CONTAINER}
                ref={this.barContainer}
            >
                <div className={CLASS_STICKY_NODE} ref={this.bar}>
                    <nav className="tabs">
                        <div className="tabs__inner">
                            <div className="tabs__list">
                                {items.map(({ value, label }) => (
                                    <a
                                        key={value}
                                        className={classnames('tabs__link', {
                                            'tabs__link--active':
                                                this.state.active === value,
                                        })}
                                        href={`#${value}`}
                                        title={label}
                                        onClick={() => {
                                            this.setState({ active: value })
                                        }}
                                    >
                                        {label}
                                    </a>
                                ))}
                            </div>
                        </div>
                    </nav>
                </div>
            </div>
        )
    }
}

export default StickyMenu



// WEBPACK FOOTER //
// /usr/src/app/frontend/src/components/StickyMenu.jsx